import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import { TitleProps } from '@widgets/ArticleTextbox/types'
import contextArticleTextbox, {
  ArticleTextboxContextType,
} from '@contexts/articleTextbox'
import { mobileCSS } from '@measures/responsive'

const { ArticleTextboxContext } = contextArticleTextbox

type StyledTitleProps = Pick<ArticleTextboxContextType, 'isPromo'>

const StyledTitle = styled.div<StyledTitleProps>`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        grey: { grey_80, grey_100 },
      },
    },
    isPromo,
  }) => css`
    font-family: ${sourceSansPro};
    font-size: 18px;
    line-height: 1.4;
    font-weight: bold;
    color: ${isPromo ? grey_100 : grey_80};
    margin: ${isPromo ? '24px 0' : '0 0 4px 0'};

    ${mobileCSS(css`
      font-size: 17px;
      line-height: 1.4;
    `)}
  `}
`

const Title: FunctionComponent<TitleProps> = ({ children }) => {
  const { isPromo } = useContext(ArticleTextboxContext)
  return (
    <StyledTitle
      isPromo={isPromo}
      dangerouslySetInnerHTML={{
        __html: children,
      }}
    />
  )
}

export default Title
